var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M15.135 7.318l-4.488-.204V3.383h-.008a2.13 2.13 0 00-2.113-1.954 2.13 2.13 0 00-2.113 1.954h-.008v5.914a2.105 2.105 0 00-2.552-.23 2.156 2.156 0 00-.765 2.79l-.007.004 3.538 5.714c.025.045.053.09.082.133.143.21.544.538.544.538.325.205.721.325 1.148.325h6.742c1.11 0 2.008-.81 2.008-1.81V9.129c0-1-.899-1.811-2.008-1.811zm-8.73 7.995l-.26-.42-.274-.43a3.273 3.273 0 01-.12-.206l-1.61-2.601.004-.002c-.366-.685-.284-1.456.207-1.766.49-.31 1.212-.048 1.662.584l.003-.003.381.616.007.014a.542.542 0 00.486.314c.238 0 .44-.157.51-.375l.01-.035V3.778h.004c.05-.777.524-1.386 1.102-1.386.579 0 1.054.609 1.103 1.386h.004v3.83a.488.488 0 00.475.486l4.395.203c.898 0 1.626.665 1.626 1.487v6.267c0 .821-.728 1.487-1.626 1.487H9.015l-.038-.001h-.015l-.023-.002c-.694-.034-1.382-.417-1.806-1.085l-.295-.465",
        "fill": "var(--mainColor)",
        "fill-rule": "nonzero"
      }
    })]));
  }
};